import DataTable from "../components/common/DataTable";
import { Button, TextInput, Modal, Group, Text, Title, Stack } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React from "react";
import Head from "../components/common/Head";
import { getSystemValues, updateSystemValues } from "../utils/api";
import useStore from "../utils/store";

const AdminValues = () => {
  const user = useStore((state) => state.user);
  const [open, setOpen] = React.useState(false);

  const getAllSystemValues = async () => {
    if (!user?.permissions?.includes("view_admin_values")) {
      notifications.show({ message: "You don't have permission to view admin values", color: "red" });
      return;
    }
    setLoading(true);
    const response = await getSystemValues();
    if (response[0]) {
      setData(response[1]);
    }
    setLoading(false);
  };

  const changeSystemValues = async () => {
    if (!user?.permissions?.includes("edit_admin_values")) {
      notifications.show({ message: "You don't have permission to edit admin values", color: "red" });
      return;
    }
    setLoading(true);
    setOpen(true);
    const response = await updateSystemValues(data);
    if (response[0]) {
      notifications.show({ message: "Successfully Updated Values", color: "green" });
      getAllSystemValues();
    }
    setOpen(false);
    setLoading(false);
  };

  const [data, setData] = React.useState({});

  const [loading, setLoading] = React.useState(true);
  

  React.useEffect(() => {
    getAllSystemValues();
  }, []);

  return (
    <Stack gap="lg" style={{ width: "100%" }}>
      <Stack gap="lg" style={{ width: "100%" }}>
        <Head title="Admin Values" />
        {!user?.permissions?.includes("view_admin_values") ? (
          <Text color="yellow">
            You don't have permission to view this page
          </Text>
        ) : (
          <>
            <DataTable
              loading={loading}
              dataSource={[data]}
              columns={[
                {
                  title: "Actions",
                  dataIndex: "actions",
                  key: "actions",
                  render: (text, record) => (
                    <Stack gap="md">
                      {user?.permissions?.includes("edit_admin_values") && (
                        <Button
                          style={{ width: "100%" }}
                          onClick={() => {
                            setOpen(true);
                            setData(record);
                          }}
                        >
                          Edit Values
                        </Button>
                      )}
                    </Stack>
                  ),
                },
                {
                  title: "UPI",
                  dataIndex: "upi",
                  key: "upi",
                },
                {
                  title: "Merchant Code",
                  dataIndex: "merchantId",
                  key: "merchantId",
                },
              ]}
            />
            <Modal
              opened={open}
              onClose={() => setOpen(false)}
              title={"Update"}
            >
              <Stack gap="md" style={{ width: "100%" }}>
                <Text style={{ marginRight: 16 }}>UPI</Text>
                <TextInput
                  placeholder="UPI"
                  onChange={(e) =>
                    setData((prev) => ({
                      ...prev,
                      upi: e.target.value,
                    }))
                  }
                  value={data?.upi}
                />
                <Text style={{ marginRight: 16 }}>
                  Merchant Code
                </Text>
                <TextInput
                  placeholder="Merchant Code"
                  onChange={(e) =>
                    setData((prev) => ({ ...prev, merchantId: e.target.value }))
                  }
                  value={data?.merchantId}
                />
              </Stack>
              <Group justify="flex-end" mt="md">
                <Button variant="default" onClick={() => setOpen(false)}>Cancel</Button>
                <Button loading={loading} onClick={changeSystemValues}>Update</Button>
              </Group>
            </Modal>
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default AdminValues;
